import icon from '@plone/volto/icons/world.svg';

import ProjectsBlockView from './Projects/BlockView';
import SingleProjectBlockView from './SingleProject/BlockView';
import StatisticsHeaderBlockView from './Statistics/HeaderBlockView';
import SpeciesStatsBlockView from './Statistics/SpeciesBlockView';
import TypeOfDetectionsBlockView from './Statistics/TypeOfDetectionsBlockView';
import DeployByWeekBlockView from './Statistics/DeployedByWeekBlockView';
import ActiveReceiverMapBlockView from './Statistics/ActiveReceiverMapBlockView';

import { projects } from './reducers';

// (Multi) Projects view
export default config => {
  config.addonReducers.projects = projects;
  config.blocks.blocksConfig.active_receiver_map_view = {
    id: 'active_receiver_map_view',
    title: 'Active Receiver Map',
    view: ActiveReceiverMapBlockView,
    icon:icon,
    group:'otn',
    restricted: false,
    mostUsed: false, 
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  },
  config.blocks.blocksConfig.deploy_by_week_view = {
    id: 'deploy_by_week_view',
    title: 'Deployed By Week Stats',
    view: DeployByWeekBlockView,
    icon:icon,
    group:'otn',
    restricted: false,
    mostUsed: false, 
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  },
  config.blocks.blocksConfig.species_stats_view = {
    id: 'species_stats_view',
    title: 'Species Stats',
    view: SpeciesStatsBlockView,
    icon:icon,
    group:'otn',
    restricted: false,
    mostUsed: false, 
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  },
  config.blocks.blocksConfig.type_of_detections_view = {
    id: 'type_of_detections_view',
    title: 'Type of Detections',
    view: TypeOfDetectionsBlockView,
    icon:icon,
    group:'otn',
    restricted: false,
    mostUsed: false, 
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  },
  config.blocks.blocksConfig.single_project_viewer = {
    id: 'single_project_viewer',
    title: 'Single Project',
    view: SingleProjectBlockView,
    icon:icon,
    group:'otn',
    restricted: false,
    mostUsed: false, 
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  },
  config.blocks.blocksConfig.statistics_header = {
    id: 'statistics_header',
    title: 'Statistics Header',
    view: StatisticsHeaderBlockView,
    icon: icon,
    group:'otn',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security:{
      addPermission: [],
      view: [],
    },
  },
  config.blocks.blocksConfig.project_viewer = {
    id: 'project_viewer',
    title: 'Projects',
    // edit: ProjectsBlockEdit,
    view: ProjectsBlockView,
    icon: icon,
    group: 'otn',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
    nodes: [
            {key: 1, fullnames:["ACT"], relation: "Node",  name:"act", color:'#019600', projsite:(node, ccode)=>{return(`project?ccode=${ccode.replace(node+'.','')}`)}},
          ],
  };
  return config
}
